// extracted by mini-css-extract-plugin
export default {"container":"AndroidWarningBanner_container__7gWUq","text":"AndroidWarningBanner_text__lNAjr"};